Namespace 'Monitoring.Views.SocialContents.Filters.PublicationsSession'

class Monitoring.Views.SocialContents.Filters.PublicationsSession.BaseFilterView extends Backbone.View

  events:
    'click a.toggle': 'toggle'

  render: ->
    @$el.html(@template)

    @renderFilters()
    @renderAppliedFilters()
    @historySessionCase()

    @

  # Contemplo este caso solo porque esta en los filtros de exploracion y review
  historySessionCase: ->
    inMyHistorySession = $('li.active a span #name').text() == 'My History'
    if inMyHistorySession
      # circumvent the hiding of filters for moderators in My History session
      @$el.find('.add-filters').attr('style', 'display:block !important')
      # remove actions menu and text/charts buttons in My History session
      $('.view-selection').remove()

  toggle: (event) =>
    @constructor.toggleFilter $(event.currentTarget).closest('.filter')

  @toggleFilter: (filter) ->
    icon = filter.find('i:not(".fa")')
    filter.toggleClass 'collapsed expanded'
    icon.toggleClass 'icon-chevron-down icon-chevron-right'
    filter.parent().find('.one-click-open').click()
